export default "__VITE_ASSET__CclNr$Ni__"